import { AssignedTagModel } from "@/common/models/tags";
import { InteractionType } from "@/common/types";
import { SentimentLabel } from "@/common/types/SentimentLabel";
import { HistoryInteractionTypes } from "@/repository/models/history";

export interface InteractionHistoryListItemDto extends HistoryListItemDto {
	queueId: string | null;
	handlingTime: string;
	handlingTimeFormatted: string;
	debuggingId: string;
	name: string;
	subject: string;
	contactInfo: string;
	isCallerWebchat?: boolean;
	isColdTransferred: boolean;
	isWarmTransferred: boolean;
}

export interface HistoryListItemDto {
	id: string;
	queueName: string;
	agentName: string;
	isAiAgent: boolean;
	isHandled: boolean;
	isInboundInteraction: boolean;
	isMissed: boolean;
	isCallback: boolean;
	arrivalTime: Date;
	endTime: Date;
	lastModificationTime: Date;
	type: InteractionType;
	interactionId: string;
	isUnify: boolean;
	hasRecording: boolean;
	overallSentiment?: SentimentLabel | null;
	assignedTags?: AssignedTagModel[];
}

export interface Note {
	note: string;
	agentId: string;
	agentName: string;
	creationTime: Date;
	type: NoteType;
	interactionId?: string;
	contactIdentifier?: string;
	isWrapUp?: boolean;
}

export enum NoteType {
	InteractionNote = 0,
	ContactNote = 1,
}

export type Params = {
	onInteractionHistorySelected: (
		historyItem?: InteractionHistoryListItemDto
	) => void;
	onHistoryPanelExtend: () => void;
};

export type SortDirection = "asc" | "desc";

export interface SortState {
	column: string | null;
	direction: SortDirection | null;
}

export enum HistoryTableColumnName {
	Name = "Name",
	ContactInfo = "ContactInfo",
	AgentName = "AgentName",
	QueueName = "Queue",
	IsHandled = "Handled",
	StartTime = "StartDate",
	EndTime = "EndDate",
	HandlingTime = "Duration",
	Sentiment = "Sentiment",
	Tags = "Tags",
	Actions = "Actions",
	LastModificationTime = "LastModificationTime",
}

export enum HistoryInteractionHandlingFilters {
	Handled = 0,
	NotHandled = 1,
}

export enum HistoryInteractionMiscellaneousFilters {
	Inbound = 0,
	Outbound = 1,
	Missed = 2,
	Transferred = 3,
}

export interface InteractionHistoryFilter {
	queueIds?: string[];

	types?: HistoryInteractionTypes[];

	handling?: HistoryInteractionHandlingFilters[];

	miscellaneous?: HistoryInteractionMiscellaneousFilters[];

	supervisedOrOperatedQueueIds?: string[];

	showMyInteractions?: boolean;
}

export const interactionHistoryTypeFilters: HistoryInteractionTypes[] =
	Object.keys(HistoryInteractionTypes)
		.map(Number)
		.filter((key: number) => !isNaN(key))
		.map((x: number) => x as HistoryInteractionTypes);

export const interactionHistoryHandlingFilters: HistoryInteractionHandlingFilters[] =
	Object.keys(HistoryInteractionHandlingFilters)
		.map(Number)
		.filter((key: number) => !isNaN(key))
		.map((x: number) => x as HistoryInteractionHandlingFilters);

export const interactionHistoryMiscellaneousFilters: HistoryInteractionMiscellaneousFilters[] =
	Object.keys(HistoryInteractionMiscellaneousFilters)
		.map(Number)
		.filter((key: number) => !isNaN(key))
		.map((x: number) => x as HistoryInteractionMiscellaneousFilters);

export interface HistoryListMobileProps {
	historyTableItems: InteractionHistoryListItemDto[];
	getItemActions: (
		item: InteractionHistoryListItemDto
	) => (JSX.Element | undefined)[];
	infiniteScrollSpinner: JSX.Element;
}
